import { types } from "./mutations";

export default {
  toggleInvitePopup({ commit }) {
    commit(types.TOGGLE_INVITE_POPUP);
  },
  toggleCreateDashboardPopup({ commit }) {
    commit(types.TOGGLE_CREATE_DASHBOARD_POPUP);
  },
  toggleDashboardSharePopup({ commit }) {
    commit(types.TOGGLE_DASHBOARD_SHARE_POPUP);
  },
  toggleVerifyEmailPopup({ commit }) {
    commit(types.TOGGLE_VERIFY_EMAIL_POPUP);
  },
  toggleWindowSelectionPopup({ commit }) {
    commit(types.TOGGLE_WINDOW_SELECTION_POPUP);
  },
  toggleComputedPropertyCreationPopup({ commit }) {
    commit(types.TOGGLE_COMPUTED_PROPERTY_POPUP);
  },
  toggleConsoleDetailsPopup({ commit }) {
    commit(types.TOGGLE_CONSOLE_DETAILS_POPUP);
  },
  toggleGridLookupPopup({ commit }) {
    commit(types.TOGGLE_GRID_LOOKUP_POPUP);
  },
  reset({ commit }) {
    commit(types.reset);
  },
};
